import styled, { css } from "styled-components";
import { DiscreetLockCircle } from "../../../../components/LockedFeatureIcon";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
  box-sizing: border-box;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`;

export const SectionBlock = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  background-color: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
  padding: 24px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 16px 14px;
    border-radius: 12px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }
`;

export const SectionTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SectionTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: var(--dark-gray);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const EditingBadge = styled.span`
  background: rgba(250, 173, 20, 0.15);
  color: #d48806;
  border: 1px solid rgba(250, 173, 20, 0.3);
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const SectionSubtitle = styled.p`
  font-size: 13px;
  color: var(--gray);
  margin: 0;
`;

export const BlockHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;

    & > * {
      width: 100% !important;
      flex: 1;
    }

    & > button,
    & > div > button,
    button {
      width: 100% !important;
      justify-content: center;
    }
  }
`;

/* --- LAYOUT PATTERN FROM /fixiter/course --- */

export const PersonTypeSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 4px;
  width: fit-content;

  @media (max-width: 768px) {
    width: 100%;

    button {
      flex: 1;
      text-align: center;
      padding: 8px 12px;
    }
  }
`;

export const SwitchButton = styled.button<{ active: boolean }>`
  padding: 8px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${({ active }) => (active ? "var(--white)" : "transparent")};
  color: ${({ active }) => (active ? "var(--fixit)" : "var(--gray)")};
  box-shadow: ${({ active }) => (active ? "0px 2px 8px rgba(0,0,0,0.05)" : "none")};

  &:disabled {
    cursor: default;
    opacity: 0.85;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const FlexInput = styled.div<{ flex?: number }>`
  flex: ${({ flex }) => flex || 1};
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TopSwitchesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    width: 100%;
    gap: 16px;
  }
`;

export const TopSwitchItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  user-select: none;
`;

export const TopSwitchLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: var(--dark-gray);
  white-space: nowrap;
  cursor: pointer;
`;

/* --- SUB-SECTIONS & TOGGLES --- */

export const HeaderToggleWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  user-select: none;
  margin-right: 4px;

  @media (max-width: 768px) {
    width: 100% !important;
    margin-right: 0;
    justify-content: flex-start;
  }
`;

export const HeaderToggleLabel = styled.label`
  font-size: 13px;
  font-weight: 500;
  color: var(--dark-gray);
  cursor: pointer;
`;

export const SubSectionDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
  margin-bottom: 2px;
`;

export const SubSectionTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: var(--dark-gray);
  margin: 0;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const SubSectionLine = styled.div`
  height: 1px;
  background-color: #f0f0f0;
  width: 100%;
`;

export const FormCheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 2px 0 6px 0;
`;

export const AddressPreviewBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background-color: #fbfbfb;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  font-size: 13px;
  color: var(--dark-gray);
`;

export const AddressPreviewText = styled.span`
  font-size: 13px;
  color: #666666;
  line-height: 1.4;
`;

export const AddressSummaryBar = styled.div<{ $isClickable?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 16px;
  background-color: #fbfbfb;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  box-sizing: border-box;
  width: 100%;
  cursor: ${({ $isClickable }) => ($isClickable !== false ? "pointer" : "default")};
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ $isClickable }) => ($isClickable !== false ? "#f5f5f7" : "#fbfbfb")};
    border-color: ${({ $isClickable }) => ($isClickable !== false ? "#d8d8d8" : "#e8e8e8")};
  }
`;

export const AddressSummaryLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1;
`;

export const AddressSummaryIconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: rgba(152, 53, 209, 0.08);
  color: var(--fixit);
  flex-shrink: 0;
`;

export const AddressSummaryText = styled.span`
  font-size: 13px;
  color: var(--dark-gray);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AddressAccordionToggleBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  color: var(--fixit);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  padding: 0;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const AddressFieldsWrapper = styled.div<{ $isExpanded: boolean }>`
  display: ${({ $isExpanded }) => ($isExpanded ? "flex" : "none")};
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

/* --- PRINTERS SECTION --- */

export const PrintersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PrinterAddRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const PrinterAddInputWrapper = styled.div`
  flex: 1;
`;

export const SelectedPrintersList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 4px;
`;

export const PrinterChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(152, 53, 209, 0.08);
  border: 1px solid rgba(152, 53, 209, 0.2);
  border-radius: 20px;
  color: var(--fixit);
  font-weight: 500;
  font-size: 13px;
`;

export const PrinterChipName = styled.span`
  white-space: nowrap;
`;

export const RemovePrinterButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border-radius: 50%;
  color: var(--error);
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

export const EmptyPrintersText = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: var(--gray);
  line-height: 1.5;
  text-align: center;
  padding: 16px 16px 24px;
  box-sizing: border-box;
`;



export const InlineCheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--dark-gray);
  cursor: pointer;
  margin-top: 8px;
  font-weight: 500;
  user-select: none;
`;

export const InlineCheckbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--fixit);
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 100px 20px;
  gap: 16px;
`;

export const LoadingText = styled.span`
  font-size: 16px;
  color: var(--gray);
  font-weight: 500;
`;

// --- USUÁRIOS (PERSON) SECTION STYLES ---
export const UsersTableWrapper = styled.div`
  width: 100%;

  /* Evita que TableContainer force min-height excessivo dentro do bloco */
  > div {
    min-height: auto;
    padding-bottom: 0;
  }

  table {
    border-spacing: 0 8px;
    margin-top: 0;
  }
`;

export const UserTableCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const UserAvatar = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(152, 53, 209, 0.1);
  color: var(--fixit);
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  text-transform: uppercase;
`;

export const UserName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: var(--black);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const UserEmailCell = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: var(--dark-gray);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const UserAccountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  background: rgba(152, 53, 209, 0.12);
  color: var(--fixit);
  border: 1px solid rgba(152, 53, 209, 0.28);
`;

export const UserPasswordActionBtn = styled.button<{ $isLoggedUser?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 7px 16px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  background: ${({ $isLoggedUser }) =>
    $isLoggedUser ? "var(--fixit)" : "#ffffff"};
  color: ${({ $isLoggedUser }) =>
    $isLoggedUser ? "#ffffff" : "var(--fixit)"};
  border: 1px solid
    ${({ $isLoggedUser }) =>
      $isLoggedUser ? "var(--fixit)" : "rgba(152, 53, 209, 0.35)"};

  &:hover:not(:disabled) {
    filter: brightness(0.95);
    background: ${({ $isLoggedUser }) =>
      $isLoggedUser ? "var(--fixit)" : "rgba(152, 53, 209, 0.06)"};
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const EmptyUsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 12px;
  border: 1px dashed #d9d9d9;
  border-radius: 12px;
  background: #fafafa;
  width: 100%;
  box-sizing: border-box;
`;

export const EmptyUsersText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: var(--gray);
  line-height: 1.5;
  text-align: center;
`;

export const ModalFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const ExpirationOutlinedContainer = styled.div<{ isEditing?: boolean }>`
  position: relative;
  width: 100%;
  height: 46px;
  border: 1px solid var(--gray);
  border-radius: 8px;
  background: ${({ isEditing }) => (isEditing ? "var(--white)" : "#efefef")};
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  transition: all 0.4s ease;

  ${({ isEditing }) =>
    isEditing &&
    css`
      &:hover {
        border-color: var(--fixit);
      }
    `}
`;

export const ExpirationNotchedLabel = styled.span<{ isEditing?: boolean }>`
  position: absolute;
  top: -7px;
  left: 12px;
  background: ${({ isEditing }) => (isEditing ? "var(--white)" : "#efefef")};
  padding: 0 6px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  color: ${({ isEditing }) => (isEditing ? "var(--fixit)" : "var(--dark-gray)")};
  transform: scale(0.75);
  transform-origin: left;
`;

export const PlanTableWrapper = styled.div`
  width: 100%;
  margin-top: 4px;

  /* Evita que TableContainer force min-height excessivo dentro do bloco */
  > div {
    min-height: auto;
    padding-bottom: 0;
  }

  table {
    border-spacing: 0 8px;
    margin-top: 0;
  }
`;

export const HistoryLinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--fixit);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: opacity 0.2s;
  align-self: flex-start;

  &:hover {
    text-decoration: underline;
    opacity: 0.85;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    padding: 8px 0;
  }
`;

export const SignatureActionColumn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    gap: 8px;
  }
`;

export const HistoryStatusBadge = styled.span<{ status: "active" | "ended" | "canceled" | "cancelled" | "blocked" }>`
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${({ status }) =>
    status === "active"
      ? `
    background: rgba(39, 174, 96, 0.12);
    color: #27ae60;
  `
      : status === "canceled" || status === "cancelled"
      ? `
    background: rgba(235, 87, 87, 0.12);
    color: #eb5757;
  `
      : status === "blocked"
      ? `
    background: rgba(242, 153, 74, 0.12);
    color: #f2994a;
  `
      : `
    background: rgba(140, 140, 140, 0.12);
    color: var(--dark-gray);
  `}
`;

export const TabsNavWrapper = styled.div<{
  $canScrollLeft?: boolean;
  $canScrollRight?: boolean;
  $isDragging?: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 18px;
  overflow-x: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  cursor: ${({ $isDragging }) => ($isDragging ? "grabbing" : "grab")};
  user-select: ${({ $isDragging }) => ($isDragging ? "none" : "auto")};

  ${({ $canScrollLeft, $canScrollRight }) => {
    if ($canScrollLeft && $canScrollRight) {
      return css`
        -webkit-mask-image: linear-gradient(
          to right,
          transparent,
          black 24px,
          black calc(100% - 24px),
          transparent 100%
        );
        mask-image: linear-gradient(
          to right,
          transparent,
          black 24px,
          black calc(100% - 24px),
          transparent 100%
        );
      `;
    }
    if ($canScrollRight) {
      return css`
        -webkit-mask-image: linear-gradient(
          to right,
          black calc(100% - 28px),
          transparent 100%
        );
        mask-image: linear-gradient(
          to right,
          black calc(100% - 28px),
          transparent 100%
        );
      `;
    }
    if ($canScrollLeft) {
      return css`
        -webkit-mask-image: linear-gradient(
          to left,
          black calc(100% - 28px),
          transparent 100%
        );
        mask-image: linear-gradient(
          to left,
          black calc(100% - 28px),
          transparent 100%
        );
      `;
    }
    return css``;
  }}

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    margin-bottom: 14px;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const TabsNavContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: max-content;
  padding: 0 2px 1px 2px;

  @media (max-width: 768px) {
    gap: 6px;
    padding: 0 4px 1px 4px;
  }
`;

export const TabNavItem = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 14px;
  background: none;
  border: none;
  border-bottom: 2px solid ${({ $active }) => ($active ? "var(--fixit)" : "transparent")};
  color: ${({ $active }) => ($active ? "var(--fixit)" : "var(--dark-gray)")};
  font-weight: ${({ $active }) => ($active ? "600" : "500")};
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  margin-bottom: -1px;
  flex-shrink: 0;

  > svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  &:hover {
    color: var(--fixit);
    background-color: rgba(152, 53, 209, 0.04);
    border-radius: 6px 6px 0 0;

    ${DiscreetLockCircle} {
      --lock-base-color: var(--fixit);
      --lock-base-border: rgba(152, 53, 209, 0.4);
      --lock-base-shadow: 0px 4px 12px rgba(152, 53, 209, 0.18);
      transform: scale(1.06);
    }
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
    font-size: 14px;
    gap: 6px;

    > svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const TabBadge = styled.span<{ $variant?: "default" | "success" | "neutral" }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 7px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  background-color: ${({ $variant }) =>
    $variant === "success"
      ? "rgba(39, 174, 96, 0.12)"
      : $variant === "neutral"
      ? "rgba(0, 0, 0, 0.06)"
      : "rgba(152, 53, 209, 0.12)"};
  color: ${({ $variant }) =>
    $variant === "success"
      ? "#27ae60"
      : $variant === "neutral"
      ? "var(--gray)"
      : "var(--fixit)"};
  white-space: nowrap;
`;

export const HeaderTitleWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
  max-width: 100%;
  min-width: 0;
`;

export const HeaderTitleText = styled.span`
  font-family: Roboto, sans-serif;
  font-size: 24px;
  font-weight: bold;
  color: var(--fixit);
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  min-width: 0;

  @media (max-width: 768px) {
    max-width: clamp(120px, calc(100vw - 195px), 320px);
  }

  @media (max-width: 480px) {
    max-width: clamp(110px, calc(100vw - 190px), 210px);
  }
`;

export const StatusPill = styled.span<{ $status?: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  font-family: Roboto, sans-serif;
  vertical-align: middle;
  flex-shrink: 0;
  white-space: nowrap;
  background-color: ${({ $status }) =>
    $status === "CANCELLED"
      ? "rgba(108, 117, 125, 0.12)"
      : $status === "BLOCKED"
      ? "rgba(235, 87, 87, 0.12)"
      : $status === "OPERATIONAL" || $status === "active"
      ? "rgba(39, 174, 96, 0.12)"
      : "rgba(0, 136, 255, 0.12)"};
  color: ${({ $status }) =>
    $status === "CANCELLED"
      ? "#6c757d"
      : $status === "BLOCKED"
      ? "#eb5757"
      : $status === "OPERATIONAL" || $status === "active"
      ? "#27ae60"
      : "var(--development)"};
`;

export const StatusBolinha = styled.span<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  display: inline-block;
  flex-shrink: 0;
`;

export const PageTopHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

export const CustomerHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const CustomerTitleName = styled.h1`
  font-size: 20px;
  font-weight: 700;
  color: var(--dark-gray);
  margin: 0;
`;

/* --- ONBOARDING & EQUIPMENTS (ADESÃO) --- */

export const OnboardingGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 100%;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const OnboardingCard = styled.div`
  background: #fafbfc;
  border: 1px solid #eaedf1;
  border-radius: 10px;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const OnboardingCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #eaedf1;
  padding-bottom: 12px;
`;

export const OnboardingCardTitle = styled.h4`
  font-size: 15px;
  font-weight: 600;
  color: var(--dark-gray);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const OnboardingDetailsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
`;

export const OnboardingDetailItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
  flex-wrap: wrap;

  .detail-label {
    color: var(--gray);
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .detail-value {
    color: var(--black);
    font-weight: 600;
    text-align: right;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
`;

export const VoltageSelectorWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const VoltageOption = styled.button<{ $active: boolean; disabled?: boolean }>`
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  border: 1px solid ${({ $active }) => ($active ? "var(--fixit)" : "#dcdcdc")};
  background: ${({ $active }) => ($active ? "rgba(152, 53, 209, 0.08)" : "var(--white)")};
  color: ${({ $active }) => ($active ? "var(--fixit)" : "var(--dark-gray)")};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    border-color: var(--fixit);
    color: var(--fixit);
  }
`;

export const ProposalDocumentButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--white);
  border: 1px solid var(--fixit);
  color: var(--fixit);
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  margin-top: 6px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(152, 53, 209, 0.06);
    text-decoration: none;
    color: var(--fixit);
  }
`;

export const EmptyOnboardingBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  color: var(--gray);
  font-size: 13px;
  text-align: center;
  gap: 8px;
`;

export const ProviderSearchWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 380px;
  display: flex;
  flex-direction: column;
  align-self: flex-end;
  margin-left: auto;

  @media (max-width: 768px) {
    max-width: 100%;
    align-self: stretch;
    margin-left: 0;
  }
`;

export const ProviderSearchContainer = styled.div<{ $disabled?: boolean }>`
  display: flex;
  width: 100%;
  height: 38px;
  box-sizing: border-box;
  position: relative;
`;

export const ProviderSearchInput = styled.input<{ $hasText?: boolean }>`
  flex: 1;
  height: 38px;
  padding: 0 36px 0 16px;
  background: transparent;
  border: 1px solid ${({ $hasText }) => ($hasText ? "var(--fixit)" : "var(--light-gray)")};
  border-right: none;
  border-radius: 20px 0 0 20px;
  font-size: 14px;
  color: var(--title);
  outline: none;
  transition: all 0.2s ease-in-out;
  box-sizing: border-box;
  margin-right: -20px;
  min-width: 0;

  &::placeholder {
    color: var(--gray);
  }

  &:focus {
    border-color: var(--fixit);
    z-index: 2;
    position: relative;
  }
`;

export const ProviderSelectedFilterBadge = styled.div`
  flex: 1;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 32px 0 12px;
  background: transparent;
  border: 1px solid var(--light-gray);
  border-right: none;
  border-radius: 20px 0 0 20px;
  box-sizing: border-box;
  margin-right: -20px;
  min-width: 0;
  cursor: default;
`;

export const ProviderSearchButton = styled.button<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 38px;
  background: transparent;
  border: 1px solid var(--fixit);
  border-radius: 20px;
  color: var(--fixit);
  cursor: pointer;
  transition: all 0.2s;
  box-sizing: border-box;
  margin-left: -20px;
  z-index: 4;
  position: relative;
  flex-shrink: 0;

  &:hover {
    background: rgba(152, 53, 209, 0.05);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ProviderSearchSuggestionsList = styled.ul`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background-color: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  padding: 4px 0;
  margin: 0;
  list-style: none;
  z-index: 100;
  overflow: hidden;
  max-height: 240px;
  overflow-y: auto;
`;

export const ProviderSearchSuggestionItem = styled.li`
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  color: var(--title);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background-color: rgba(152, 53, 209, 0.05);
    color: var(--fixit);
  }
`;

/* --- SIGNATURE STATES & EMPTY STATE --- */

export const EmptySignatureNotice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 18px;
  background: #fafbfc;
  border: 1px dashed #cfd7df;
  border-radius: 8px;
  margin-bottom: 8px;
`;

export const EmptySignatureTitle = styled.h4`
  font-size: 15px;
  font-weight: 600;
  color: var(--dark-gray);
  margin: 0;
`;

export const EmptySignatureDescription = styled.p`
  font-size: 13.5px;
  color: var(--sub-title);
  margin: 0;
  line-height: 1.5;
`;

export const WarningNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background-color: #fff9e6;
  border: 1px solid #ffe58f;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 13px;
  line-height: 1.45;
  color: #874d00;
  margin-bottom: 16px;
`;

export const DangerDeleteNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background-color: #fff1f0;
  border: 1px solid #ffa39e;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 13px;
  line-height: 1.45;
  color: #cf1322;
  margin-bottom: 16px;
`;

export const ActionIconButton = styled.button<{ color?: string }>`
  background: transparent;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 6px;
  color: ${(props) => props.color || "var(--dark-gray)"};
  transition: all 0.2s ease-in-out;

  &:hover {
    background: ${(props) =>
      props.color === "var(--error)" || props.color === "#eb5757"
        ? "rgba(235, 87, 87, 0.12)"
        : "rgba(0, 0, 0, 0.05)"};
    color: ${(props) =>
      props.color === "var(--error)" || props.color === "#eb5757"
        ? "var(--error)"
        : "var(--fixit)"};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const LocatorPhotoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 4px 0 8px 0;
  background: transparent;
  border: none;
  margin-bottom: 0;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 100px 1fr;
    grid-template-areas:
      "text text"
      "photo actions";
    column-gap: 16px;
    row-gap: 14px;
    align-items: center;
  }
`;

export const LocatorPhotoPreview = styled.div`
  position: relative;
  display: inline-block;
  width: 100px;
  height: 100px;
  flex-shrink: 0;
  align-self: flex-end;
  grid-area: photo;

  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: var(--dark-gray);
    object-fit: cover;
    display: block;
  }
`;

export const LocatorOfficialStarBadge = styled.div<{ $isGold?: boolean }>`
  position: absolute;
  bottom: 5px;
  right: 5px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: ${({ $isGold }) => ($isGold ? "#F5C518" : "#A0A0A0")};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;

  svg {
    fill: white;
    display: block;
    margin-bottom: 2px;
  }
`;

export const LocatorPhotoInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  @media (max-width: 768px) {
    display: contents;
  }
`;

export const LocatorPhotoText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  grid-area: text;

  .photo-title {
    font-size: 14px;
    font-weight: 600;
    color: var(--dark-gray);
  }

  .photo-subtitle {
    font-size: 12px;
    color: var(--gray);
  }
`;

export const LocatorPhotoActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
  flex-wrap: wrap;
  grid-area: actions;

  @media (max-width: 768px) {
    margin-top: 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const LocatorPhotoUploadBtn = styled.button`
  background: var(--fixit);
  color: #ffffff;
  border: none;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LocatorPhotoDeleteBtn = styled.button`
  background: transparent;
  color: #ef4444;
  border: 1px solid #fca5a5;
  border-radius: 20px;
  padding: 5px 12px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;

  &:hover {
    background: #fef2f2;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LocatorStarsGrid = styled.div`
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  width: 100%;
  margin-top: -10px;
  margin-bottom: 4px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    margin-top: -10px;
  }
`;

export const LocatorStarCard = styled.div<{
  $tier: "silver" | "gold";
  $active?: boolean;
  $locked?: boolean;
  $hasTopArrow?: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  transition: all 0.2s ease;
  box-sizing: border-box;

  ${({ $tier, $active, $locked }) => {
    if ($locked) {
      return css`
        background: #f9fafb;
        border: 1px dashed #d1d5db;
        cursor: pointer;

        &:hover {
          border-color: rgba(152, 53, 209, 0.35);

          ${DiscreetLockCircle} {
            --lock-base-color: var(--fixit);
            --lock-base-border: rgba(152, 53, 209, 0.4);
            --lock-base-shadow: 0px 4px 12px rgba(152, 53, 209, 0.18);
            transform: scale(1.06);
          }
        }
      `;
    }
    if ($tier === "gold" && $active) {
      return css`
        background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 55%, #fffbeb 100%);
        border: 1.5px solid #f59e0b;
        box-shadow: 0 2px 8px rgba(245, 158, 11, 0.1);
      `;
    }
    if ($tier === "silver" && $active) {
      return css`
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        border: 1.5px solid #94a3b8;
        box-shadow: 0 2px 6px rgba(100, 116, 139, 0.08);
      `;
    }
    return css`
      background: #fafbfc;
      border: 1px solid #e5e7eb;
    `;
  }}

  ${({ $hasTopArrow, $tier }) =>
    $hasTopArrow &&
    css`
      &::before {
        content: "";
        position: absolute;
        top: -9.5px;
        left: 72px;
        width: 0;
        height: 0;
        border-left: 9px solid transparent;
        border-right: 9px solid transparent;
        border-bottom: 9px solid ${$tier === "gold" ? "#f59e0b" : "#94a3b8"};
      }

      &::after {
        content: "";
        position: absolute;
        top: -7.5px;
        left: 72px;
        width: 0;
        height: 0;
        border-left: 9px solid transparent;
        border-right: 9px solid transparent;
        border-bottom: 9px solid ${$tier === "gold" ? "#fffbeb" : "#f8fafc"};
      }
    `}
`;

export const LocatorStarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
`;

export const LocatorStarTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

export const LocatorStarIconBox = styled.div<{
  $tier: "silver" | "gold";
  $locked?: boolean;
}>`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 2px solid #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  background-color: ${({ $tier }) => ($tier === "gold" ? "#F5C518" : "#A0A0A0")};
  opacity: ${({ $locked }) => ($locked ? 0.75 : 1)};

  svg {
    fill: #ffffff;
    display: block;
    margin-bottom: 1px;
  }
`;

export const LocatorStarTitleTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
  min-width: 0;
`;

export const LocatorStarTitle = styled.h4`
  font-size: 13.5px;
  font-weight: 700;
  color: var(--dark-gray);
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const LocatorStarSubtitle = styled.span`
  font-size: 11.5px;
  font-weight: 500;
  color: var(--gray);
`;

export const LocatorStarStatusBadge = styled.span<{
  $variant: "silver-active" | "gold-active" | "included" | "locked";
}>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;

  ${({ $variant }) => {
    switch ($variant) {
      case "gold-active":
        return css`
          background: #fef3c7;
          color: #b45309;
          border: 1px solid #fcd34d;
        `;
      case "silver-active":
        return css`
          background: #e2e8f0;
          color: #334155;
          border: 1px solid #cbd5e1;
        `;
      case "included":
        return css`
          background: rgba(39, 174, 96, 0.12);
          color: #27ae60;
        `;
      case "locked":
        return css`
          background: rgba(152, 53, 209, 0.08);
          color: var(--fixit);
        `;
    }
  }}
`;

export const LocatorStarDescription = styled.p<{ $locked?: boolean }>`
  font-size: 12px;
  line-height: 1.35;
  color: ${({ $locked }) => ($locked ? "#6b7280" : "var(--sub-title)")};
  margin: 0;
`;

/* --- CERTIFICATE & CLASS LINK STYLES --- */

export const CertificateClassBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 18px;
  background: #fafbfc;
  border: 1px solid #eaedf1;
  border-radius: 10px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 14px;
  }
`;

export const CertificateClassInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
`;

export const CertificateClassIconBox = styled.div`
  width: 42px;
  height: 42px;
  min-width: 42px;
  border-radius: 50%;
  background-color: rgba(152, 53, 209, 0.07);
  color: var(--fixit);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CertificateClassTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const CertificateClassLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: var(--gray);
`;

export const CertificateClassName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: var(--dark-gray);
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const CertificateUnavailableCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px 24px;
  background: #fafbfc;
  border: 1px dashed #cfd7df;
  border-radius: 12px;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
`;

export const CertificateUnavailableTitle = styled.h4`
  font-size: 15px;
  font-weight: 600;
  color: var(--dark-gray);
  margin: 0;
`;

export const CertificateUnavailableMessage = styled.p`
  font-size: 13.5px;
  color: var(--sub-title);
  margin: 0;
  line-height: 1.5;
  max-width: 520px;
`;



